export default "__VITE_ASSET__48c8fd76__"